import { Component } from '@angular/core';

/**
 * ControlloQualityComponent — placeholder "Pagina in costruzione".
 *
 * 🚨 v2.12.1 R.3 (Phase 1.5 closure): la pagina di controllo qualità
 * NON è stata restyled durante Phase 1.5 (decisione PM 2026-06-22 —
 * pagina sub-secondaria del workflow magazzino, low priority, restyle
 * reale rimandato a Phase 2). Per evitare che l'utente veda il design
 * legacy datato — kendo-grid + tabella inconsistente col resto del
 * design system Diakonix — la pagina mostra ora un placeholder
 * Diakonix "Pagina in costruzione" finché Phase 2 non arriva con il
 * restyle vero.
 *
 * Cleanup v2.12.1:
 * - Dropped ~150 LOC di state (gridData, pmOrders, partials, gridView,
 *   loading, pagination, kendo-grid binding, ecc.).
 * - Dropped 2 import legacy (`@progress/kendo-angular-grid`, OrdersService).
 * - Dropped `OnInit` lifecycle e tutta la subscribe API.
 * - I 5 sub-component sotto `preparazione-ordini-detaggli/` (controllo-
 *   dettagli + controllo-bolla + controllo-ddt + controllo-quantità +
 *   controllo-prodotti) restano intatti — verranno restyled in Phase 2
 *   insieme al main shell vero.
 *
 * La route `/quality-check` resta navigabile, l'utente vede comunque
 * un'area visivamente coerente Diakonix invece di un kendo-grid vuoto
 * o malformato.
 */
@Component({
  selector: 'app-controllo-quality',
  templateUrl: './controllo-quality.component.html',
  styleUrls: ['./controllo-quality.component.scss'],
  standalone: false,
})

export class ControlloQualityComponent { }
